import React, { Component } from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { Redirect, Switch } from 'react-router'
import ManageSettings  from './ManageSettings';
import AccountOverview from './AccountOverview';
import MmaLeftNav from './MmaLeftNav';
import OrganizationInviteUsers from './OrganizationInviteUsers';
import UpgradePersonalAccount from './UpgradePersonalAccount';
import {getUser} from './../firstnetSubscriberOnboarding/GetUser';
import AppCatalog from './AppCatalog';
import MyApis from './MyApis';

class MmaRouter extends Component {
    constructor (props) {
        super(props);
        this.state = {
            active: false,
            currentUser:"",
            appCatalogParent:[],
            appCatalogCurrentPage:0,
            appCatalogItemsPerPage:10,
            appCatalogPageItemsParent:[],
            showAppcatalogInOverview:true
        }
    }

    componentDidMount() {
        console.log('in MmaRouter componentDidMount');
        getUser(this.updateUserInfo);
    }

    updateUserInfo = (currentUser) => {
      this.setState({
        currentUser: currentUser
      });
      console.log('updateUserInfo complete');
    }

    updatePageInfo = (currentPage, pageItems) => {
        this.setState({
            appCatalogCurrentPage : currentPage,
            appCatalogPageItemsParent : pageItems
        });
    }

    updateAppCatalog = (appCatalog) => {
    	console.log('in updateAppCatalog')
        if(appCatalog.length === 0){
            this.setState({
                showAppcatalogInOverview:false
            })
        } else if(appCatalog.length > this.state.appCatalogItemsPerPage){
            this.setState({
                appCatalogParent: appCatalog,
                appCatalogPageItemsParent : appCatalog.slice(this.state.appCatalogCurrentPage, this.state.appCatalogItemsPerPage)
            });
        } else {
            this.setState({
                appCatalogParent: appCatalog,
                appCatalogPageItemsParent : appCatalog
            });
        }
    }

    render() {
        return(
            <Router>
                <Route render = {({ location, history }) => (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-2 col-lg-3 col-xl-2">
                                <MmaLeftNav
                                    location={location}
                                    history={history}
                                    currentUser={this.state.currentUser}
                                />
                            </div>
                            <div className="col-10 col-lg-9 col-xl-10 bg-gray-light main-content">
                                <main className="row">
                                    <Switch>
                                        <Redirect exact from="/" to="/accountOverview" push />
                                        <Route exact path="/accountOverview" >
                                            <AccountOverview
                                                currentUser={this.state.currentUser}
                                                catalog={this.state.appCatalogParent}
                                                pageItems={this.state.appCatalogPageItemsParent}
                                                itemsPerPage={this.state.appCatalogItemsPerPage}
                                                showAppcatalogInOverview={this.state.showAppcatalogInOverview}
                                                updateAppCatalog={this.updateAppCatalog}
                                                updatePageInfo={this.updatePageInfo}
                                        />
                                        </Route>
                                        <Route path="/manageSettings"
                                            component={() => <ManageSettings
                                                currentUser={this.state.currentUser}
                                            />}
                                        />
                                        <Route path="/manageSettings"
                                            component={() => <ManageSettings
                                                currentUser={this.state.currentUser}
                                            />}
                                        />
                                        <Route path="/myApis" exact component={() => <MyApis/>} />
                                        <Route path="/myApps" >
                                            <AppCatalog
                                                catalog={this.state.appCatalogParent}
                                                pageItems={this.state.appCatalogPageItemsParent}
                                                itemsPerPage={this.state.appCatalogItemsPerPage}
                                                updateAppCatalog={this.updateAppCatalog}
                                                updatePageInfo={this.updatePageInfo}
                                                isPaginationRequired={true}
                                            />
                                        </Route>
                                        <Route path="/OrganizationInviteUsers" exact component={() => <OrganizationInviteUsers/>} />
                                    <Route path="/upgradeIndividualAccount" exact component={() => <UpgradePersonalAccount/>} />
                                    </Switch>
                              </main>
                            </div>
                        </div>
                    </div>
                    )}
                />
             </Router>
        )
    }
}

export default MmaRouter;



// WEBPACK FOOTER //
// ./src/manageMyAccount/MmaRouter.js